import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCanAccessInternalRoutes } from '@/hooks/featureFlags';

export const InternalOnlyRoute = ({ children }: { children: React.ReactNode }) =>
  useCanAccessInternalRoutes() ? children : <Navigate to="/" replace />;

/* to keep the naming consistent with other feature flag route components
/ we export specific feature route components
/ The following lines are to ignore coverage as they are simple re-exports
/* istanbul ignore next */
export const GameDashboardFeatureRoute = InternalOnlyRoute;
